import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as dateutil from '@/util/date-helper'

@Component({
})
export default class ApprovalInfo extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) item!: any;
    @Prop({ type: Boolean, default: true }) detail!: any;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getDate(dateStr: string, format: string) {
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr));
    }
}
